import { forEach } from "angular";
import { timeout } from "neo-async";

export const cartManager =  function ( httpManager,loadingManager ) {
	var cart = [];
	var showCart = false;
	var shouldShowCart = false;
	var updated = false;
	var updateCart = false;

	function getCartItemsCallback( response ) {
		if(shouldShowCart){
			shouldShowCart = false;
			showCart = true;
		}
		
		if(updateCart){
			updateCart = false;
			getCart();
		} else
			loadingManager.hide();
		
		cart = response.data.items;
	}

	function getCartItemsErrorCallback(error){
		loadingManager.hide();
		console.log('error',error.data);
		if(error.data.status == 422){
			document.getElementById('sdToastHeader').innerHTML = 'Oops!';
			document.getElementById('sdToastDescription').innerHTML = error.data.message;
			const toastLiveExample = document.getElementById('liveToast');
			const toast = new bootstrap.Toast(toastLiveExample);
    		toast.show()
		}		
	}

	function getCart(){
		httpManager.getRequester(window.Shopify.routes.root + 'cart.js',{},false,getCartItemsCallback);
	}

	function getCartItemsTotal(){
		var count = 0;
		cart.forEach(item => {
			count = count + Number(item.quantity);
		});
		return count;
	}

   	return { 
		cart: function(){
			return cart;
		},setCart: function (newCart) {
			cart = newCart;
		},addToCart: function (id,openCart,properties) {
			loadingManager.show('Adding to Cart');
			shouldShowCart = openCart;
			updateCart = true;
			httpManager.postRequester(window.Shopify.routes.root + 'cart/add.js',{items: [{id: id,quantity: 1,properties : properties}]},true,getCartItemsCallback,getCartItemsErrorCallback);
		},changeCart: function (id,quantity) {
    		loadingManager.show('Removing from Cart');
			httpManager.postRequester(window.Shopify.routes.root + 'cart/change.js',{line: id, quantity: quantity},true,getCartItemsCallback);
		},toggleCart: function () {
			showCart = !showCart;
		},cartState: function () {
			return showCart;
		},cartSubTotal:  function () {
			var cartSubTotal = 0;
			cart.forEach(item => {
				cartSubTotal =  cartSubTotal + (item.quantity * item.price);
			});
			return cartSubTotal;
		},getCart: function () {
			getCart();
		},getCartItems: function () {
			return cart;
		},getCartItemsTotal: function() {			
			return getCartItemsTotal();
		}, updated:  function(){
			return updated;
		}, orderPossible: function(){
			return !updated || getCartItemsTotal() > 9;
		}
   	};
};